module.exports = __webpack_public_path__ + "img/side_img.63329c56.png";